// App.jsx
import { useState, useEffect, useRef } from "react";
import Login from "./Login";
import MainApp from "./MainApp";
import { isTokenValid, removeToken } from "./utils/auth";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const hasCheckedAuth = useRef(false); // Prevent double auth check

  useEffect(() => {
    // Check if user is already authenticated on app start
    if (!hasCheckedAuth.current) {
      hasCheckedAuth.current = true;
      
      if (isTokenValid()) {
        setAuthenticated(true);
      } else {
        removeToken(); // Remove invalid token
      }
      setLoading(false);
    }
  }, []);

  const handleLogin = () => {
    setAuthenticated(true);
  };

  const handleLogout = () => {
    removeToken();
    setAuthenticated(false);
  };

  if (loading) {
    return (
      <div style={{ 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "var(--light-gray)",
        color: "var(--text-light)",
        fontSize: "18px"
      }}>
        🔄 Loading...
      </div>
    );
  }

  return (
    <div>
      {authenticated ? (
        <MainApp onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
